import { createAction } from 'redux-actions';
import { PapiGallection } from '@wix/da-papi-types';
import { actionKey } from '../constants';

export const addBookmark = createAction(
  `${actionKey}.BOOKMARKS.ADD`,
  (gallection: PapiGallection) => ({ gallection })
);

export const undoAddBookmark = createAction(
  `${actionKey}.BOOKMARKS.UNDO_ADD`,
  (gallection: PapiGallection) => ({ gallection })
);

export const removeBookmark = createAction(
  `${actionKey}.BOOKMARKS.REMOVE`,
  (gallection: PapiGallection) => ({ gallection })
);

export const repositionBookmark = createAction(
  `${actionKey}.BOOKMARKS.REPOSITION`,
  (gallection: PapiGallection, position: number) => ({ gallection, position })
);
